// test2739
(2739 && 0);
